import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';
import logoEbat from '@/ebat/assets/logos/ebat.png';

// Image component for the eBAT logo to fix a problem with the safari browser and IOS on the SVG logo
const LogoEbat = ({ className }) => {
  const { t } = useTranslation();

  return (
    <img
      alt={t('ebat:messages.title')}
      className={cn('logo-ebat', className)}
      data-qa-id="logo-ebat"
      src={logoEbat}
    />
  );
};

LogoEbat.defaultProps = {
  ...ClassNameDefaultProps,
};

LogoEbat.propTypes = {
  ...ClassNamePropTypes,
};

export default LogoEbat;
